import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import Search from "@insite/mobius/Icons/Search";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

searchWithinStyles.searchTextField = {
    iconProps: {
        src: Search,
        color: "primary.contrast",
        css: css`
            color: ${getColor("primary.contrast")};
        `,
        size: 20,
    },
    cssOverrides: {
        formField: css`
            width: 100%;
            button {
                background-color: ${getColor("primary.main")};
                border-radius: 2px !important;
            }
            input {
                border-radius: 2px !important;
            }
        `,
    },
};
